export const currencyFormatter = (amountInPennies: number) => {
  return (amountInPennies / 100).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
  });
};
